import { useEffect } from 'react';
import { FONT_CHOICES, fontHref } from './elements';
import { fontsInText } from './richTextModel';

/** The Google fonts a deck uses: the deck font, fonts set on free elements, and fonts picked for words ({f:…|…} spans). */
export function deckFontFamilies(slides: any[], deckFont?: unknown): string[] {
  const known = (f: unknown): f is string => typeof f === 'string' && FONT_CHOICES.some((c) => c.family === f);
  const fams = new Set<string>();
  if (known(deckFont)) fams.add(deckFont);
  for (const sl of slides || []) for (const el of (Array.isArray(sl?.elements) ? sl.elements : [])) if (known(el?.font)) fams.add(el.font);
  for (const f of fontsInText(JSON.stringify(slides || []))) if (known(f)) fams.add(f);
  return [...fams];
}

/** Load those fonts once per page (one <link>, updated as the deck changes). */
export function useDeckFonts(slides: any[] | undefined, deckFont?: unknown): void {
  const fams = deckFontFamilies(slides || [], deckFont).join('|');
  useEffect(() => {
    if (!fams) return;
    const id = 'deck-element-fonts';
    let link = document.getElementById(id) as HTMLLinkElement | null;
    if (!link) { link = document.createElement('link'); link.id = id; link.rel = 'stylesheet'; document.head.appendChild(link); }
    const href = fontHref(fams.split('|')); if (link.href !== href) link.href = href;
  }, [fams]);
}
